import React, {useState} from 'react';
import MyInput from "../../components/UI/MyInput/MyInput";
import MyButton from "../../components/UI/MyButtons/MyButton";
import {useNavigate} from "react-router-dom";
import Service from "../../API/Service";

const DepAddPage = () => {
    const navigate = useNavigate();

    const [updatedData, setUpdatedData] = useState({
        id: "",
        code: "",
        nameKey: "",
        nameMap: { kk: "", ru: "", en: "" }
    });

    const handleChange = (field, value) => {
        setUpdatedData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleNameMapChange = (lang, value) => {
        setUpdatedData(prev => ({
            ...prev,
            nameMap: { ...prev.nameMap, [lang]: value }
        }));
    };

    const createDep = async () => {
        try {
            const response = await Service.createDep(updatedData, "departments");
            alert("Департамент успешно создан!");
            navigate(-1);
        } catch (error) {
            alert("Ошибка при создании департамента!");
        }
    };

    return (
        <div className={"constants__wrap"}>
            <h1>Departments</h1>
            <div className={"content"}>
                <MyInput
                    onChange={(value) => handleChange("code", value)}
                    info={{ name: "Constant code", value: updatedData.code }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleNameMapChange("en", value)}
                    info={{ name: "Department name (English)", value: updatedData.nameMap.en }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleNameMapChange("kk", value)}
                    info={{ name: "Department name (Kazakh)", value: updatedData.nameMap.kk }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleNameMapChange("ru", value)}
                    info={{ name: "Department name (Russian)", value: updatedData.nameMap.ru }}
                    isDisabled={false}
                />

                <div className={"buttons"}>
                    <MyButton
                        content={"Back"}
                        isBlue={false}
                        onClick={() => navigate(-1)}
                    />
                    <MyButton
                        content={"Create new department"}
                        isBlue={true}
                        onClick={createDep}
                    />
                </div>
            </div>
        </div>
    );
};

export default DepAddPage;